import { TemplateElement, html, defineElement } from '@webtides/element-js';
import BuyBoxEvents from '../../structures/_buy-box/buy-box/BuyBoxEvents';
import ShoppingCartEvents from '../../structures/_shopping-cart/ShoppingCartEvents';
import { CartCookie } from '../../../js/cookies/cart-cookie';

export default class CartCount extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            count: false,
            url: '',
        };
    }

    connected() {
        this.updateCartCount();
    }

    updateCartCount() {
        const { count } = CartCookie.get();
        this.count = count;
    }

    events() {
        return {
            document: {
                [ShoppingCartEvents.CART_CHANGED]: e => {
                    this.updateCartCount();
                },
            },
        };
    }

    template() {
        if (!this.count) return '';

        return html` <div class="count">${this.count}</div> `;
    }
}

defineElement('cart-count', CartCount);
